import React from 'react';
import Link from 'next/link';
import { Clock, Users, Trophy } from 'lucide-react';

const related = [
  { id: 'rel-1', title: 'Science & Technology Quiz', category: 'Knowledge', prize: '$1,500', entry: '$5', participants: '1,204', timeLeft: '6h', emoji: '🔬' },
  { id: 'rel-2', title: 'History Masters Tournament', category: 'Knowledge', prize: '$2,000', entry: '$8', participants: '892', timeLeft: '1d', emoji: '📜' },
  { id: 'rel-3', title: 'Business & Finance Quiz', category: 'Knowledge', prize: '$800', entry: '$5', participants: '412', timeLeft: '3h', emoji: '💹' },
  { id: 'rel-4', title: 'Current Affairs Daily', category: 'Knowledge', prize: '500 XP', entry: 'Free', participants: '3,421', timeLeft: '12h', emoji: '📰' },
];

export default function RelatedActivities() {
  return (
    <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
      <h2 className="text-base font-bold text-foreground mb-5">Similar Competitions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
        {related?.map((item) => (
          <Link href="/activity-detail-page" key={item?.id}
            className="activity-card p-4 block">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center text-xl"
                style={{ background: 'var(--muted)' }}>
                {item?.emoji}
              </div>
              <span className="text-xs font-semibold uppercase tracking-wide" style={{ color: '#A78BFA' }}>{item?.category}</span>
            </div>
            <h3 className="text-sm font-bold text-foreground mb-2 leading-tight">{item?.title}</h3>
            <div className="space-y-1 text-xs" style={{ color: 'var(--muted-foreground)' }}>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1"><Trophy size={10} style={{ color: '#F59E0B' }} />{item?.prize}</span>
                <span className="font-semibold text-foreground">{item?.entry}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1"><Users size={10} />{item?.participants}</span>
                <span className="flex items-center gap-1"><Clock size={10} />{item?.timeLeft}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}